import { Paper, MenuItem } from "@mui/material";
import { useTranslation } from "react-i18next";

interface OcrControlsProps {
  onFullScreenshot: () => void;
  onSelectRegion: () => void;
  isProcessing: boolean;
  popupAbove: boolean;
}

export default function OcrControls({
  onFullScreenshot,
  onSelectRegion,
  isProcessing,
  popupAbove,
}: OcrControlsProps) {
  const { t } = useTranslation(["bugherd"]);

  return (
    <Paper
      elevation={4}
      sx={{
        position: "absolute",
        ...(popupAbove
          ? { bottom: "100%", mb: 1 }
          : { top: "100%", mt: 1 }),
        left: "50%",
        transform: "translateX(-50%)",
        borderRadius: "8px",
        backgroundColor: "#fff",
        zIndex: 10,
        minWidth: 180,
        overflow: "hidden",
      }}
      onClick={(e) => e.stopPropagation()}
    >
      <MenuItem
        onClick={onFullScreenshot}
        disabled={isProcessing}
        sx={{ fontSize: 13 }}
      >
        {t("fullScreenshot")}
      </MenuItem>
      <MenuItem
        onClick={onSelectRegion}
        disabled={isProcessing}
        sx={{ fontSize: 13 }}
      >
        {t("selectRegion")}
      </MenuItem>
    </Paper>
  );
}
